import * as React from 'react';
import * as CheckboxPrimitive from '@radix-ui/react-checkbox';
import { Check } from 'lucide-react';
import { cn } from 'utils';

const Checkbox = React.forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
// eslint-disable-next-line
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={cn(
      'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=checked]:text-primary-foreground transition-colors duration-300',
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      forceMount
      className={cn(
        'flex items-center justify-center text-current transition-[opacity,transform]',
        'data-[state=checked]:duration-300 data-[state=checked]:ease-[cubic-bezier(0.175,0.885,0.32,1.275)]',
        'data-[state=unchecked]:duration-300 data-[state=unchecked]:ease-out',
        'data-[state=unchecked]:opacity-0 data-[state=unchecked]:scale-0',
        'data-[state=checked]:opacity-100 data-[state=checked]:scale-100',
      )}
    >
      <Check className="h-4 w-4" />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
